import React, { useState } from "react";
import UseCasesCard from "./UseCasesCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";


type UseCasesSliderMobileProps = {
  data?: any;
};

const UseCasesSliderMobile: React.FC<UseCasesSliderMobileProps> = ({
  data = [],
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="mt-8">
      <div className="xl:hidden block container">
        <div>
          <Swiper

            className="h-full"
            modules={[Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            slidesPerView={1}
            spaceBetween={15}
            centeredSlides={true}
            loop={true} // Enables infinite loop without jumping
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          >
            {data.map((item: any, index: number) => (
              <SwiperSlide key={"Swiper" + index}>
                <div key={index} className="h-full">
                  <UseCasesCard
                    title={item.title}
                    description={item.description}
                    imageUrl={item.imageUrl}
                    buttonLabel={item.buttonLabel}
                    buttonLink={item.buttonLink}
                  />
                </div>
              </SwiperSlide>



            ))}
          </Swiper>
        </div>

        <div className="md:hidden block">
          {/* Custom Pagination */}
          <div className="mt-[30px] lg:mt-[15px] flex justify-center items-center gap-2 px-12 py-6 sm:w-[67%] mx-auto relative sm:absolute bottom-[15%] lg:bottom-[20%] left-[50%] sm:transform -translate-x-[50%] z-[5]">
            {[0, 1, 2].map((idx) => (
              <div
                key={idx}
                className={`p-0 relative rounded overflow-hidden ${activeIndex === idx
                  ? " flex w-[128px] h-1 bg-background"
                  : "flex-none w-[16px] h-1 bg-background"
                  }`}
              >
                <span
                  className={`absolute top-0 rounded left-0  h-1 ${activeIndex === idx
                    ? "bg-gradient-to-r from-[#8ABC00] to-[#0086E6] transition-all duration-[4000ms] w-[128px] "
                    : "left-[-100%] w-[16px] "
                    }`}
                ></span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UseCasesSliderMobile;
